export const GET_LEARNER_PROGRESS_BLOOM = "GET_LEARNER_PROGRESS_BLOOM";
export const GET_LEARNER_PROGRESS_BLOOM_SUCCESS = "GET_LEARNER_PROGRESS_BLOOM_SUCCESS";
export const GET_LEARNER_PROGRESS_BLOOM_FAIL = "GET_LEARNER_PROGRESS_BLOOM_FAIL";

export const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  